/**
 * Error messages for the FRISCO upload flow, so every failed call stops the loader
 * with a message the uploader can act on instead of leaving it spinning.
 */

// How long to wait for the backend to report sheet names or validation results
// before giving up. Both normally arrive within seconds.
export const UPLOAD_STEP_TIMEOUT_MS = 5 * 60 * 1000;

export const UPLOAD_STEP_TIMEOUT_MESSAGE =
    'Checking the file is taking longer than expected. Please upload it again, and contact support if it keeps happening.';

export const DOUBLE_DOT_FILE_NAME_MESSAGE = "File names can't contain '..'. Rename the file and upload it again.";

const KNOWN_ERRORS = [
    {
        // Vault rejects any key containing '..' (Vault/VaultUtils.py validate_path).
        match: /directory traversal/i,
        message: DOUBLE_DOT_FILE_NAME_MESSAGE,
    },
];

/**
 * Vault rejects '..' anywhere in a key, so a file named e.g. "hello..xlsx" would upload
 * here but its raw copy (stored under the original name) could never be downloaded.
 * Reject it up front instead.
 */
export const validateFileNameForVault = (file) => {
    if (file?.name?.includes('..')) {
        throw { error: 'INVALID FILE NAME', message: DOUBLE_DOT_FILE_NAME_MESSAGE };
    }
};

const rawMessage = (error) => {
    if (!error) return '';
    if (typeof error === 'string') return error;
    // AppSync / Amplify GraphQL errors: { errors: [{ message }] }
    const gqlMessage = error?.errors?.[0]?.message || error?.error?.errors?.[0]?.message;
    return gqlMessage || error?.message || '';
};

/**
 * A readable message for a failed upload call: a known cause gets plain wording,
 * otherwise the fallback, followed by the underlying reason when there is one.
 */
export const getUploadErrorMessage = (error, fallback) => {
    const raw = rawMessage(error);
    const known = KNOWN_ERRORS.find((k) => k.match.test(raw));
    if (known) return known.message;
    return raw ? `${fallback} (${raw})` : fallback;
};
